/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Modal,
    Text,
    Flex,
    Button,
} from '@mantine/core';

import { observer } from 'mobx-react';
import useIsMobile from '../../hooks/isMobile';
import { useStore } from '../../hooks/use-store';
import { NOTIFICATION_SERVICE } from '../../components/notifications/NotificationService';


export const Element = (props: {
    opened: boolean
    close: () => void
}) => {

    const {
        uiStore: { authStore },
        dataStore: { appStore },
    } = useStore();

 
    const isMobile = useIsMobile()
    const packs = [
        { id: 'p80', credits: 80, price: 80 * 0.258, bestDeal: false },
        { id: 'p170', credits: 170, price: 170 * 0.258, bestDeal: false },
        { id: 'p380', credits: 380, price: 380 * 0.258, bestDeal: false },
        { id: 'p840', credits: 840, price: 840 * 0.258, bestDeal: true },
        { id: 'p1700', credits: 1700, price: 1700 * 0.258, bestDeal: false },
    ] as const

 
    return (
        <Modal
            opened={props.opened}
            onClose={props.close}

            styles={{
                body: {
                    background: '#1a1a1a',
                },
                header: {
                    background: '#1a1a1a'
                },
                content: {
                    background: '#1a1a1a',
                },
            }}
            size={isMobile ? 'xl' : '1300px'}
            // withinPortal
            zIndex={1000}
            // fullScreen
            title={''}
            padding={0}
        >
            <Flex direction={'column'} w={'100%'} p={isMobile ? 16 : 28} gap={isMobile ? 10 : 18}>
                <Flex direction={'column'} align={'center'} gap={8}>
                    <Text color={'#ffffff'} fz={isMobile ? 26 : 42} fw={700} lts={-1} align='center'>Pick your credit pack</Text>
                    <Text color={'#aaaaaa'} fz={isMobile ? 12 : 14} align='center'>Get access to more generations and priority access to new features</Text>
                </Flex>

                <Flex wrap={'nowrap'} gap={isMobile ? 12 : 18} justify={'center'} style={{ overflowX: isMobile ? 'auto' : 'hidden' }}>
                    {packs.map((pack) => {
                        const imageGenerations = Math.floor(pack.credits / 2);
                        const videoGenerations = Math.floor(pack.credits / 100);
                        const highlighted = pack.bestDeal;
                        return (
                            <Flex
                                key={pack.id}
                                direction={'column'}
                                w={isMobile ? '100%' : 220}
                                p={16}
                                gap={14}
                                pos={'relative'}
                                style={{
                                    borderRadius: 16,
                                    background: highlighted ? 'rgba(86, 122, 12, 0.2)' : '#121212',
                                    border: highlighted ? '1px solid #a5e51e' : '1px solid #2a2a2a',
                                }}
                            >
                                <Flex justify={'space-between'} align={'center'}>
                                    <Flex direction={'column'} gap={2}>
                                        <Text color={'#ffffff'} fz={22} fw={700}>{pack.credits} Credits</Text>
                                        <Text color={'#8a8a8a'} fz={12}>Valid for 90 days</Text>
                                    </Flex>
                                    {highlighted && (
                                        <Flex bg={'#a5e51e'} style={{ borderRadius: 9999 }} px={4} py={4} pos={'absolute'} top={26} right={14}>
                                            <Text fz={8} fw={700} color={'#0b0b0b'}>BEST DEAL</Text>
                                        </Flex>
                                    )}
                                </Flex>

                                <Flex direction={'column'} gap={10} mt={4}>
                                    <Flex gap={8} align={'center'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#a5e51e"><path d="M20.285 6.709l-11.285 11.291-5.285-5.291 1.414-1.414 3.871 3.877 9.871-9.877z"/></svg>
                                        <Text color={'#cccccc'} fz={10}>Up to {imageGenerations} image generations</Text>
                                    </Flex>
                                    <Flex gap={8} align={'center'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#a5e51e"><path d="M20.285 6.709l-11.285 11.291-5.285-5.291 1.414-1.414 3.871 3.877 9.871-9.877z"/></svg>
                                        <Text color={'#cccccc'} fz={10}>Up to {videoGenerations + 1} video generations</Text>
                                    </Flex>
                                </Flex>

                                <Flex justify={'space-between'} align={'center'} mt={6}>
                                    <Text color={'#ffffff'} fz={24} fw={700}>€{pack.price}</Text>
                                </Flex>

                                <Button
                                    mt={4}
                                    fullWidth={true}
                                    styles={{
                                    
                                        root: {
                                            height: '44px',
                                            fontSize: '16px',
                                            background: highlighted ? '#a5e51e' : '#fff',
                                            color: highlighted ? '#111111' : '#111111',
                                            border: 'none',
                                            "&:hover": {
                                                backgroundColor: highlighted ? '#76a216 !important' : '#d4d4d4 !important',
                                                color: highlighted ? '#111111 !important' : '#111111 !important',
                                            }
                                        },
                                    
                                    }}
                                    onClick={async () => {
                                        const res = await appStore.getCheckoutLink({
                                            credits: pack.credits,
                                            boosted: true
                                        })

                                        if (res?.url) {
                                            const anchor = document.createElement('a');
                                            anchor.target = '_blank';
                                            anchor.href = res.url;
                                            anchor.click();
                                            props.close();
                                        } else {
                                            NOTIFICATION_SERVICE.errorNotification('Something went wrong');
                                        }
                                    }}
                                >
                                    Purchase
                                </Button>
                            </Flex>
                        )
                    })}
                </Flex>
            </Flex>
        </Modal >
    )
}

export const BuyCreditsModal = observer(Element);